<template lang="html">

  <section class="video-historias-dcoop" :show="show ? 'true' : 'false'">
    <div class="contenedor-video row-center">
      <button @click="closeVideo" class="cerrar">✕</button>
      <iframe allowscriptaccess="always" :src="'https://www.youtube.com/embed/'+id+'?enablejsapi=1&version=3&playerapiid=ytplayer'"></iframe>
    </div>
  </section>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'video-viewer',
    props: ['id', 'show'],
    mounted() {

    },
    data() {
      return {
        video_id : this.id,
      }
    },
    methods: {
      closeVideo : function(){
        this.$emit('closeVideo');
      }
    },
    computed :{
      ...mapGetters(['getLanguage']),
    },
    watch: {
    // whenever question changes, this function will run
    show: function () {
      if(this.show){
        this.video_id = this.id;
      }else{
        this.video_id = 'stop';
      }
    }
  },

}
</script>

<style scoped>

.video-historias-dcoop{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.7);
  z-index: 20;
  transform: translateY(110vw);
  opacity: 0;
  transition: opacity .2s 0s, transform .2s .25s; 
}

.video-historias-dcoop[show="true"]{
  opacity: 1;
  transform: translateY(0);
  transition: opacity .2s .25s, transform .2s 0s;
}


.contenedor-video{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

iframe{
  width: 75vw;
  height: 551px;
  border: none;
  max-width: 980px;
  transition: transform .8s .5s, box-shadow .4s 1.4s;
  transform: translateY(150vh);
}

[show="true"] iframe{
  transform: translateY(0);
  box-shadow: 1px 1px 50px 2px rgba(0, 0, 0, 0.76);
}

.cerrar{
  position: absolute;
  right: 20px;
  top: 80px;
  background: none;
  border: none;
  font-size: 30px;
  color: white;
  cursor:pointer;
  transition: .3s;
  outline: none;
}



@media screen and (max-width: 1300px){

  iframe{
    height: 42.18vw;
  }

}



</style>



// WEBPACK FOOTER //
// src/components/parts/video-viewer.vue